export default "__VITE_ASSET__$mnKC7bw__"